import { render, staticRenderFns } from "./DialogOverlay.vue?vue&type=template&id=c83717d4"
import script from "./DialogOverlay.vue?vue&type=script&lang=js"
export * from "./DialogOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports